import { SentimentAPI } from "@givesentiment/api";
import { Config } from "./config";

export const getApi = (): SentimentAPI => {
  const config = Config.getInstance();
  const { environmentId, apiHost } = config.get();

  if (!environmentId || !apiHost) {
    throw new Error("sentiment.init() must be called before getApi()");
  }

  return new SentimentAPI({
    apiHost,
    environmentId,
  });
};
